export const Mobile = {
    heading1: `
        font-weight: 600;
        font-size: 30px;
        line-height: 36px;
    `,
    heading2: `
        font-weight: 600;
        font-size: 20px;
        line-height: 26px;
    `,
    heading3: `
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
    `,
    heading4: {
        normal: `
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
        `,
        bold: `
            font-weight: 600;
            font-size: 16px;
            line-height: 22px;
        `,
        regular: `
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
    `,
    },
    large: {
        semibold: `
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
        `,
        medium: `
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
        `,
        regular: `
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
        `,
    },
    medium: {
        semibold: `
            font-weight: 600;
            font-size: 12px;
            line-height: 18px;
        `,
        medium: `
            font-weight: 500;
            font-size: 12px;
            line-height: 18px;
        `,
        regular: `
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
        `,
    },
    normal: {
        semibold: `
            font-weight: 600;
            font-size: 10px;
            line-height: 16px;
        `,
        medium: `
            font-weight: 500;
            font-size: 10px;
            line-height: 16px;
        `,
        regular: `
            font-weight: 400;
            font-size: 10px;
            line-height: 16px;
        `,
    },
    small: {
        semibold: `
            font-weight: 600;
            font-size: 8px;
            line-height: 14px;
        `,
        medium: `
            font-weight: 500;
            font-size: 8px;
            line-height: 14px;
        `,
        regular: `
            font-weight: 400;
            font-size: 8px;
            line-height: 14px;
        `,
    },
    caption: {
        semibold: `
            font-weight: 600;
            font-size: 12px;
            line-height: 18px;
        `,
        medium: `
            font-weight: 500;
            font-size: 12px;
            line-height: 18px;
        `,
    },
};
